import * as React from 'react'

export type LocationVariant = 'origin' | 'destination'

export type LocationFlags = Record<LocationVariant, boolean>

const EMPTY_LOCATION_FLAGS: LocationFlags = {
  origin: false,
  destination: false,
}

export interface UseLocationFlagsResult {
  terminalSaved: LocationFlags
  contactSaved: LocationFlags
  onSaveAsTerminal: (variant: LocationVariant) => void
  onClearTerminal: (variant: LocationVariant) => void
  onSaveAsContact: (variant: LocationVariant) => void
  onClearContact: (variant: LocationVariant) => void
}

export function useLocationFlags(): UseLocationFlagsResult {
  const [terminalSaved, setTerminalSaved] =
    React.useState<LocationFlags>(EMPTY_LOCATION_FLAGS)
  const [contactSaved, setContactSaved] =
    React.useState<LocationFlags>(EMPTY_LOCATION_FLAGS)

  const onSaveAsTerminal = React.useCallback((variant: LocationVariant) => {
    setTerminalSaved((prev) => ({ ...prev, [variant]: true }))
    setContactSaved((prev) => ({ ...prev, [variant]: true }))
  }, [])

  const onClearTerminal = React.useCallback((variant: LocationVariant) => {
    setTerminalSaved((prev) => ({ ...prev, [variant]: false }))
    setContactSaved((prev) => ({ ...prev, [variant]: false }))
  }, [])

  const onSaveAsContact = React.useCallback((variant: LocationVariant) => {
    setContactSaved((prev) => ({ ...prev, [variant]: true }))
  }, [])

  const onClearContact = React.useCallback((variant: LocationVariant) => {
    setContactSaved((prev) => ({ ...prev, [variant]: false }))
  }, [])

  return {
    terminalSaved,
    contactSaved,
    onSaveAsTerminal,
    onClearTerminal,
    onSaveAsContact,
    onClearContact,
  }
}
